import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle, Mail, Phone } from 'lucide-react';
import { CATEGORY_COLORS } from '../constants/categoryColors';

function Footer() {
  const categories = Object.entries(CATEGORY_COLORS);

  return (
    <footer className="text-white mt-12 relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #1A1A2E 0%, #0F3460 100%)' }}>
      <div className="absolute top-0 left-0 right-0 h-1.5" style={{ background: 'linear-gradient(90deg, #DC2626 0%, #D97706 25%, #FFB703 50%, #059669 75%, #7C3AED 100%)' }}></div>
      <div className="max-w-[1600px] mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="/logo.jpeg"
                alt="Crime Newz"
                className="h-12 w-12 object-contain bg-white rounded-md p-1"
              />
              <h3 className="text-xl font-black tracking-tighter">
                CRIME NEWZ
              </h3>
            </div>
            <p className="text-sm text-[#A0A0B5] leading-relaxed">
              Your trusted source for crime news and investigations. Stay informed, stay safe.
            </p>
          </div>

          <div>
            <h4 className="text-xs tracking-[0.2em] uppercase font-bold mb-4 text-[#FFB703]">
              CATEGORIES
            </h4>
            <ul className="space-y-2">
              {categories.map(([slug, c]) => (
                <li key={slug}>
                  <a
                    href={`#${slug}`}
                    className="group inline-flex items-center gap-2 text-sm text-[#A0A0B5] hover:text-white transition-colors"
                  >
                    <span
                      className="w-2 h-2 rounded-full group-hover:scale-150 transition-transform"
                      style={{ backgroundColor: c.bg }}
                    ></span>
                    {c.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs tracking-[0.2em] uppercase font-bold mb-4 text-[#FFB703]">
              CONTACT TIP LINE
            </h4>
            <div className="space-y-3">
              <a href="mailto:tips@crimenewz.com" className="flex items-center gap-3 text-sm text-[#A0A0B5] hover:text-white transition-colors">
                <div className="p-2 bg-[#E63946] bg-opacity-20 border border-[#E63946]">
                  <Mail size={14} className="text-[#E63946]" />
                </div>
                tips@crimenewz.com
              </a>
              <a href="tel:1-800-JUSTICE" className="flex items-center gap-3 text-sm text-[#A0A0B5] hover:text-white transition-colors">
                <div className="p-2 bg-[#FFB703] bg-opacity-20 border border-[#FFB703]">
                  <Phone size={14} className="text-[#FFB703]" />
                </div>
                1-800-JUSTICE
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-[#525252] pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-[#A0A0B5]">
            © 2026 <span className="text-[#FFB703] font-bold">Crime Newz</span>. All rights reserved.
          </p>
          <div className="flex items-center gap-5 text-xs">
            <Link
              to="/privacy-policy"
              data-testid="footer-privacy-link"
              className="text-[#A0A0B5] hover:text-[#FFB703] transition-colors tracking-[0.1em] uppercase font-bold"
            >
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
